module.exports = __webpack_public_path__ + "img/workOrderTanker1.023a0269.png";